import { ListingDetail } from '@deltek/specification-client/core/Models/listing'
import { createDevStore } from 'bpm/shared/utils/devtools'
import { create, StateCreator } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type CopyMoveParamsType = Record<string, string | Partial<ListingDetail>[]>

export type ListingPageStoreType = {
    isLoading: boolean
    hasNextPage: boolean
    showBulkActions: boolean
    enableBulkActions: boolean
    copyMoveParams: CopyMoveParamsType
    bulkActionProgress: Record<string, string>
    filterValues: Record<string, string[]>
    listingURLSearch: string
    setIsListingLoading: (isLoading: boolean) => void
    setHasNextPage: (hasNextPage: boolean) => void
    setShowBulkActions: (showBulkActions: boolean) => void
    setEnableBulkActions: (enableBulkActions: boolean) => void
    setCopyMoveParams: (copyMoveParams: CopyMoveParamsType) => void
    setBulkActionProgress: (bulkActionProgress: Record<string, string>) => void
    setFilterValues: (filterValues: Record<string, string[]>) => void
    setListingURLSearch: (listingURLSearch: string) => void
}

const store = createDevStore(
    persist(
        (set) => ({
            isLoading: false,
            hasNextPage: true,
            showBulkActions: false,
            enableBulkActions: false,
            copyMoveParams: {},
            bulkActionProgress: {},
            filterValues: {},
            listingURLSearch: '',
            setIsListingLoading: (isLoading: boolean) => set({ isLoading }),
            setHasNextPage: (hasNextPage: boolean) => set({ hasNextPage }),
            setShowBulkActions: (showBulkActions: boolean) =>
                set({ showBulkActions }),
            setEnableBulkActions: (enableBulkActions: boolean) =>
                set({ enableBulkActions }),
            setCopyMoveParams: (copyMoveParams: any) => set({ copyMoveParams }),
            setBulkActionProgress: (
                bulkActionProgress: Record<string, string>
            ) => set({ bulkActionProgress }),
            setFilterValues: (filterValues: Record<string, string[]>) =>
                set({ filterValues }),
            setListingURLSearch: (listingURLSearch: string) =>
                set({ listingURLSearch }),
        }),
        {
            name: 'listings-page',
            storage: createJSONStorage(() => localStorage),
        }
    ) as StateCreator<ListingPageStoreType, [], [['zustand/persist', unknown]]>,
    'LISTING_PAGE'
)

export const useListingPageStore = create(store)
